import { Toast } from "primereact/toast";
import { styled } from "@linaria/react";

export const PToastStyle = {
  Toast: styled(Toast)<{ ref: React.ForwardedRef<Toast> }>`
    .p-toast-message-content {
      max-width: 400px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `,
};
